export default __webpack_public_path__ + "static/media/100.295f1a4e.jpg";